import { createContext, useContext } from "react";

import type { ToastRequest } from "@/ui/composed/toast/Toast";

interface ToastContextProps {
  showToast: (config: ToastRequest) => void;
}

const ToastContext = createContext<ToastContextProps | undefined>(undefined);

const useToast = (): ToastContextProps => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
export type { ToastContextProps };
export { ToastContext, useToast };
